// extracted by mini-css-extract-plugin
export var jumbotron = "jumbotron-1R_";
export var body = "body-20z";
export var darker = "darker-2WY";
export var jumbotron_content = "jumbotron_content-2ny";
export var buttons = "buttons-3Rv";
export var no_background = "no_background-2qJ";
export var video_wrapper = "video_wrapper-3v3";
export var card_wrapper = "card_wrapper-3KV";
export var jumbotron_background_image = "jumbotron_background_image-29K";